<template>
  <div class="w-full h-full flex flex-col">
    <h3 class="py-0 my-0 mb-2 text-xl text-gray-800">
      Kennzahlen Serviceberater
    </h3>

    <mia-routing-tabs>
      <mia-routing-tab
        v-for="route in childRoutes"
        :key="route.name"
        :to="{ name: route.name }"
      >
        {{ route.meta.title }}
      </mia-routing-tab>
    </mia-routing-tabs>

    <div class="p-2 flex-1 overflow-x-hidden overflow-y-auto">
      <router-view />
    </div>
  </div>
</template>

<script>
import RoutingTabs from '@/components/ui/tabs/RoutingTabs.vue'
import RoutingTab from '@/components/ui/tabs/RoutingTab.vue'

export default {
  components: {
    'mia-routing-tab': RoutingTab,
    'mia-routing-tabs': RoutingTabs
  },

  computed: {
    serviceRoute() {
      return this.$router.options.routes.find(route => route.name === 'service.index')
    },

    indexRoute() {
      return this.serviceRoute.children.find(route => route.name === 'service.operatingNumbersServiceConsultant.index')
    },

    childRoutes() {
      return this.indexRoute.children.filter(route => !route.meta.hideFromNavigation)
    }
  },

  mounted() {
    this.$nextTick(() => {
      eventBus.$emit('mia-set-breadcrumb', [
        {
          link: {
            path: '/service'
          },
          text: 'Service'
        },
        {
          link: {
            path: '/service/kennzahlen-serviceberater'
          },
          text: 'Kennzahlen Serviceberater'
        }
      ])
    })
  }
}
</script>
